import './find.js';
import './details.js';
import './inbox.js';
import {clans} from './clans.js';
import {clans_create_onload, clans_add_event_handlers_to_tag_field, clans_add_event_handlers_to_name_field} from './create.js';
window.clans = clans;
window.clans_create_onload = clans_create_onload;
window.clans_add_event_handlers_to_tag_field = clans_add_event_handlers_to_tag_field;
window.clans_add_event_handlers_to_name_field = clans_add_event_handlers_to_name_field;
